module.exports = __webpack_public_path__ + "img/mi-herhaal-recepten.48899c26.svg";